<template>
  <span class="inline-flex items-center gap-1.5 text-xs font-medium text-white">
    <sparkles-icon class="size-3.5" />
    <template v-if="showLabel">
      {{ tr('Created with Ai') }}
    </template>
  </span>
</template>

<script>
import { Sparkles } from '@lucide/vue';

export default {
  name: 'AiCreatedBadge',
  components: {
    SparklesIcon: Sparkles,
  },
  props: {
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
